import {
  GET_REPORTED_REELS,
  DISMISS_REEL_REPORT,
  DELETE_REPORTED_REEL,
} from "./types";

const initialState = {
  reportedReels: [],
};

const ReportedReelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORTED_REELS:
      return {
        ...state,
        reportedReels: action.payload,
      };
    case DISMISS_REEL_REPORT:
    case DELETE_REPORTED_REEL:
      return {
        ...state,
        reportedReels: state.reportedReels.filter(
          (data) => data._id?._id !== action.payload.postId,
        ),
      };
    default:
      return state;
  }
};

export default ReportedReelsReducer;
